import { config } from '../../config';
import { ZendeskLegacy } from './zendesk-legacy.class';
import { ZendeskChatOnly } from './zendesk-chat-only.class';

const zendeskInstance = () => {
    switch (config?.zendesk?.version) {
        case 'chat-only':
            return new ZendeskChatOnly();
        case 'legacy':
            return new ZendeskLegacy();
        default:
            throw Error('Unsupported Zendesk version.');
    }
};

export const zendeskChat: any = config.zendesk ? zendeskInstance() : null;
